import { useState, useCallback, useEffect } from "react";
import { SettingLinks } from "../premiumPaywallCheckout";
import * as  axios from 'axios';
import PaywallCheckoutPersonalDetails from "./paywallCheckoutPersonalDetails"
import PaywallCheckoutPaymentDetails from "./paywallCheckoutPaymentDetails"
import PaywallCheckoutFinish from "./paywallCheckoutPaymentFinish"
import PaywallCheckoutMultiStepsProgressbar from "./multiStepProgressbar/paywallCheckoutMultiStepsProgressbar"
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { getNewlinkTargetProperties } from "widgets/widgetsUtils"
import { useRedirect } from "../../../../../global/paywall/useRedirect";
import PremiumPaywallCheckoutPlans, { defaultPlansObj } from "../../../paywallForms/desktop/premiumPaywallPlans";
import { SubscriptionPlan, PaywallPlans, SiteLinks, CustomerAccessData } from "../../../../../global/paywall/paywallInterfaces";
import { getPaywallSettingsFromLocalStorage } from "../../../../../global/paywall/authOperations";
import { getPaywallAccessData } from "../../../../../global/paywall/paywallApiUrls";
import { ynetProductClientId, hasProductClientId } from "../../../../../global/paywall/paywallUtils";

interface PaywallCheckoutComponentaProps {
    settingLinks: SettingLinks;
}


declare const window: Window & {
    PAYWALL_PLANS: PaywallPlans
    PAYWALL_SITE_LINKS: SiteLinks;
}


export const PaywallCheckoutComponenta = (props: PaywallCheckoutComponentaProps) => {

    const [currentStepIndex, setCurrentStepIndex] = useState<number>(0);
    const [selectedPlan, setPlan] = useState<SubscriptionPlan>(null);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const { settingLinks } = props;
    const [fallbackUrl, setFallbackUrl] = useState<string>(settingLinks.postPurchase.url);
    const legalLinks = {
        terms: settingLinks.terms,
        privacy: settingLinks.privacy,
    };
    useRedirect({ fallbackUrl: fallbackUrl, enabled: shouldRedirect });


    const plansObj: PaywallPlans =
        typeof window !== 'undefined' && window.PAYWALL_PLANS
            ? window.PAYWALL_PLANS
            : defaultPlansObj;

    const checkUserAccess = useCallback(async (): Promise<boolean> => {
        try {
            const userDetails = getPaywallSettingsFromLocalStorage();
            if (!userDetails) {
                setFallbackUrl(settingLinks.authPage.url);
                setShouldRedirect(true);
                return false;
            }

            const response = await axios.get<{ data: CustomerAccessData }>(getPaywallAccessData());
            const accessData = response && response.data && response.data.data as CustomerAccessData;

            if (!accessData) {
                setFallbackUrl(settingLinks.authPage.url);
                setShouldRedirect(true);
                return false;
            }
            const hasProducts = hasProductClientId(accessData.claims, ynetProductClientId);
            if (hasProducts) {
                setFallbackUrl(settingLinks.postPurchase.url);
                setShouldRedirect(true);
                return false;
            }

            return true;
        } catch (error) {
            console.error("Error fetching customer data:", error);
            setFallbackUrl(settingLinks.authPage.url);
            setShouldRedirect(true);
            return false;
        }
    }, [settingLinks]);


    useEffect(() => {
        if (typeof window === 'undefined') return;
        checkUserAccess();
        const searchParams = new URLSearchParams(window.location.search);
        const selected = searchParams.get('selected');

        if (selected) {
            setPlan(plansObj[selected] || null);
            nextStep();
        }
    }, []);


    enum CheckoutStep {
        SELECT_PLAN = "בחירת מסלול",
        PERSONAL_DETAILS = "פרטי מנוי",
        PAYMENT_DETAILS = "פרטי תשלום",
        FINISH = "סיום",
    }

    const steps = Object.values(CheckoutStep);
    const nextStep = (plan?) => {
        if (plan) {
            setPlan(plan);
        }
        setCurrentStepIndex(Math.min(currentStepIndex + 1, steps.length - 1));
    };

    const prevStep = () => {
        setCurrentStepIndex(Math.max(currentStepIndex - 1, 0));
    };

    const currentStepClass = Object.keys(CheckoutStep)[currentStepIndex] || '';



    const renderStepContent = () => {
        switch (steps[currentStepIndex]) {
            case CheckoutStep.SELECT_PLAN:
                return <PremiumPaywallCheckoutPlans insideCheckoutFlow={true} legalLinks={legalLinks} nextStep={nextStep} />;
            case CheckoutStep.PERSONAL_DETAILS:
                return <PaywallCheckoutPersonalDetails nextStep={nextStep} prevStep={prevStep} settingLinks={settingLinks} />;
            case CheckoutStep.PAYMENT_DETAILS:
                return <PaywallCheckoutPaymentDetails nextStep={nextStep} prevStep={prevStep} selectedPlan={selectedPlan} />;
            case CheckoutStep.FINISH:
                return <PaywallCheckoutFinish selectedPlan={selectedPlan} setShouldRedirect={setShouldRedirect} nextStep={nextStep} />;
            default:
                return null;
        }
    };

    return (
        <div className={`PaywallCheckoutComponenta ${currentStepClass}`}>
            <div className="welcome-image-cover"></div>
            <div className="main-container">
                <div className="title-container">
                    <span className="title">רכישת מינוי </span>
                    <span className="yedioth-plus-logo"></span>
                </div>
                <PaywallCheckoutMultiStepsProgressbar steps={steps} currentStepIndex={currentStepIndex} />
                <div className="line-divider"></div>
                <div className="step-content-container">
                    {renderStepContent()}
                </div>
                <div className="footer">
                    <div className="footer-links">
                        <ul>
                            <li><HyperLinkBuilder linkTarget={getNewlinkTargetProperties()} href={'https://www.ynet.co.il/plus/contact'}>צור קשר</HyperLinkBuilder></li>
                            <li>|</li>
                            <li><HyperLinkBuilder linkTarget={legalLinks.privacy.target} href={legalLinks.privacy.url}> מדיניות פרטיות</HyperLinkBuilder></li>
                        </ul>
                    </div>
                    <div className="footer-terms-text">
                        לביטול מנוי ידיעות+ כדין יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים:  <a target="_blank" href="https://www.ynet.co.il/plus/contact">מילוי טופס</a> או בדוא״ל <a href="mailto:support.plus@ynet.co.il">support.plus@ynet.co.il</a>  או בת.ד 438 ראשון לציון או בטל׳  3733* / 03-6933933 או בפקס 03-6933999 | ידיעות מנויים ח.פ 540181054
                </div>
                </div>
            </div>

        </div>
    )
}

PaywallCheckoutComponenta.siteScriptName = "PaywallCheckoutComponenta"
